import { FastlyImage } from '@components/common/image'
import Ratings from '@components/common/ratings'
import Partners from '@components/locale-pages/home/us/partners'
import PhoneInputContainer from '@containers/phone-input'
import { useEffect } from 'react'

const FirstFold = () => {
  useEffect(() => {
    document.getElementById('phone').focus()
  }, [])

  return (
    <>
      <div className="relative flex justify-between px-5 md:px-3 pt-8 overflow-visible lg:rounded-b-lg">
        <div className="container mx-auto flex flex-col text-grey z-5 lg:flex-row lg:items-start gap-5">
          <div className="flex flex-col max-w-6xl">
            <h1 className="max-w-2xl text-center font-600 lg:text-left custom-home-h1">
              Online teaching & tuition jobs - teach coding, math, or public
              speaking to kids (grades 1-12)
            </h1>
            <p className="font-400 text-lg md:text-xl text-center md:text-left my-3 md:my-0 md:mt-5 max-w-4xl">
              Join Codingal as a remote teacher and teach AI, Coding, Math, or
              Public Speaking & Communication through live 1:1 or small group
              classes, with training, curriculum, and full support.
            </p>
            <div className="text-left w-full sm:w-auto pt-5">
              <PhoneInputContainer
                isErrorDarkRed
                buttonText="Become a teacher"
                isInputFieldBorderGrey
                isTeacherSignup
                isInHomePage
                buttonClassName="truncate"
              />
            </div>
            <div className="flex justify-center lg:justify-start pt-10">
              <Ratings isDarkText showGlassdoor />
            </div>
          </div>
          <div className="mx-auto lg:flex-shrink-0 lg:my-8">
            <FastlyImage
              src="/images/teacher-lp/firstFold/hero-v2.png"
              alt="teacher hero"
              height={472}
              width={579}
              priority
              loading="eager"
            />
          </div>
        </div>
      </div>
      <div className="bg-orange-100">
        <Partners />
      </div>
    </>
  )
}

export default FirstFold
